module.exports = __webpack_public_path__ + "img/news_decoration.4bf7a5a7.svg";